// extracted by mini-css-extract-plugin
export default {"link":"NavBarLink_link__0Vvoj"};